import { ref, type InjectionKey, type Ref } from "vue";
import type Lenis from "lenis";
import type { ScrollToOptions } from "lenis";

export interface LenisScrollContext {
  scrollY: Readonly<Ref<number>>;
  scrollTo: (target: number | string | HTMLElement, options?: ScrollToOptions) => void;
  isLenisActive: Readonly<Ref<boolean>>;
  lenis: Readonly<Ref<Lenis | undefined>>;
}

export const LENIS_SCROLL_KEY: InjectionKey<LenisScrollContext> = Symbol("lenis-scroll");

// router scrollBehavior에서 Lenis 인스턴스에 접근하기 위한 브릿지 ref
// PublicLayout이 마운트될 때만 값이 채워지고, admin 등 Lenis 미사용 영역에서는 undefined
export const routerLenisRef = ref<Lenis | undefined>();
